const SITE_NAME = 'PREFERE PLUS';
const SITE_URL = 'https://recrutement-prefereplus.com';
const DEFAULT_IMAGE = SITE_URL + '/prefer-meta.png';

const routeSEO = {
  'Home1': {
    title: 'Cabinet Conseil RH, Recrutement & Formation - Cotonou, Benin',
    description: 'Cabinet PREFERE PLUS : recrutement, formation professionnelle, conseil en GRH au Benin. +50 entreprises partenaires, +2000h de formation depuis 2012.',
    canonical: '/',
  },
  'About': {
    title: 'Qui sommes-nous - Cabinet RH depuis 2012',
    description: 'Decouvrez PREFERE PLUS, cabinet conseil en management des ressources humaines base a Cotonou. 11 domaines d\'expertise, +50 entreprises partenaires.',
    canonical: '/about',
  },
  'Services': {
    title: 'Nos Services - Recrutement, Formation, Conseil RH',
    description: 'Recrutement, chasse de tete, formation professionnelle, conseil en GRH, audit social. Decouvrez nos 6 poles de services en ressources humaines.',
    canonical: '/services',
  },
  'Formations': {
    title: 'Catalogue Formations 2026 - 48 formations inter + 29 intra-entreprise',
    description: 'Consultez notre catalogue de formations professionnelles 2026 a Cotonou : GRH, management, fiscalite, droit du travail, ISO, Excel. A partir de 250 000 FCFA.',
    canonical: '/formations',
  },
  'JobOffers': {
    title: 'Offres d\'emploi au Benin - Recrutement en cours',
    description: 'Consultez nos offres d\'emploi au Benin. PREFERE PLUS recrute pour ses entreprises partenaires : postulez en ligne avec tests psychotechniques.',
    canonical: '/job-offers',
  },
  'Blog': {
    title: 'Blog RH - Actualites et conseils en ressources humaines',
    description: 'Articles, conseils et actualites en management des ressources humaines, recrutement et formation professionnelle au Benin.',
    canonical: '/blog',
  },
  'Event': {
    title: 'Evenements - Seminaires et formations a venir',
    description: 'Retrouvez nos prochains evenements, seminaires et sessions de formation organisees par le cabinet PREFERE PLUS a Cotonou.',
    canonical: '/evenements',
  },
  'Faq': {
    title: 'FAQ - Questions frequentes',
    description: 'Reponses aux questions frequentes sur nos services de recrutement, formation et conseil en ressources humaines.',
    canonical: '/faq',
  },
  'Contact': {
    title: 'Nous contacter - Cotonou, Benin',
    description: 'Contactez le cabinet PREFERE PLUS a Cotonou. Tel : 01 40 11 88 84. Email : prefereplus@gmail.com. Carre 808, Aidjedo.',
    canonical: '/contact',
  },
  'JobOfferDetails': {
    title: 'Details de l\'offre d\'emploi',
    description: 'Consultez le detail de cette offre d\'emploi et postulez en ligne sur PREFERE PLUS.',
    canonical: '/job-offers',
  },
  'Login': {
    title: 'Connexion candidat',
    description: 'Connectez-vous a votre espace candidat PREFERE PLUS pour suivre vos candidatures et passer vos tests.',
  },
  'Register': {
    title: 'Inscription candidat',
    description: 'Creez votre compte candidat PREFERE PLUS pour postuler aux offres d\'emploi et acceder aux tests psychotechniques.',
  },
};

function updateMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (el) {
    el.setAttribute('content', content);
  } else {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    el.setAttribute('content', content);
    document.head.appendChild(el);
  }
}

function updateCanonical(path) {
  let el = document.querySelector('link[rel="canonical"]');
  const url = SITE_URL + (path || '/');
  if (el) {
    el.setAttribute('href', url);
  } else {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.setAttribute('href', url);
    document.head.appendChild(el);
  }
}

export function applySEO(routeName, customData = {}) {
  const seo = routeSEO[routeName] || {};
  const title = customData.title || seo.title || 'Cabinet Conseil RH';
  const description = customData.description || seo.description || '';
  const image = customData.image || DEFAULT_IMAGE;
  const canonical = customData.canonical || seo.canonical || '';

  // Title
  document.title = `${title} | ${SITE_NAME}`;

  // Standard meta
  updateMeta('description', description);

  // Open Graph
  updateMeta('og:title', `${title} | ${SITE_NAME}`, true);
  updateMeta('og:description', description, true);
  updateMeta('og:image', image, true);
  updateMeta('og:url', SITE_URL + canonical, true);

  // Twitter
  updateMeta('twitter:title', `${title} | ${SITE_NAME}`, true);
  updateMeta('twitter:description', description, true);
  updateMeta('twitter:image', image, true);

  // Canonical
  if (canonical) {
    updateCanonical(canonical);
  }
}

export function setupRouterSEO(router) {
  router.afterEach((to) => {
    applySEO(to.name);
  });
}
